// @ts-nocheck
import { flow, Instance, types, getRoot } from 'mobx-state-tree';
import { SecretariatNeighbor } from './models/SecretariatNeighbor';
import { getEnvironment } from './utils';
import { getBaseStore } from './BaseStore';
import { ApplicationStore } from './ApplicationStore';
import { Page } from '../common/enums';
import { RootStoreType } from './RootStore';

interface SearchCriteria {
  secretariatId?: number;
}

export const SecretariatNeighborStore = types
  .compose(
    getBaseStore<Instance<typeof SecretariatNeighbor>, Instance<typeof SecretariatNeighbor>>(
      SecretariatNeighbor,
      'secretariatNeighborId',
      'secretariatNeighbor',
    ),
    types.model('SecretariatNeighborStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          secretariatNeighborId: undefined,
          secretariatId: undefined,
          pharmacyId: undefined,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const getBySecretariatById = flow(function*(secretariatId: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          secretariatNeighborId: undefined,
          secretariatId: undefined,
          pharmacyId: undefined,
        };
      }
    });

    // const search = flow(function*(criteria: Instance<typeof SearchCriteria>) {
    //   const result = yield apiFetcher.get('secretariatNeighbors', {
    //     params: {
    //       ...criteria,
    //     },
    //   });
    //   const resultSecretariatNeighbor: Array<Instance<typeof SecretariatNeighbor>> = [];
    //   // @ts-ignore
    //   result.forEach((node) => {
    //     const secretariatNeighbor = updatePharmacyInStore(node);
    //     resultSecretariatNeighbor.push(secretariatNeighbor);
    //   });
    //   return resultSecretariatNeighbor;
    // });

    return {
      getBySecretariatById,
    };
  });
